import { CreatePatient, Patient } from 'models/patients.model';
import { Gender, Person, RelationInfo, RelationUsualInfo, ShortenPerson } from 'models/profile.model';
import { MedicalStaff } from 'models/record.model';
import { capitalize } from './String.func';
import { CNS_CODE } from 'utils/Constants';

export const getInitials = (person: Person | ShortenPerson | RelationInfo | RelationUsualInfo) => {
  return `${person?.first_name ? person?.first_name[0] : ''}${person?.last_name ? person?.last_name[0] : ''}`.toUpperCase();
};

export const getFullName = (person: Person | ShortenPerson | RelationInfo | RelationUsualInfo) => {
  return `${person?.first_name} ${person?.last_name?.toUpperCase()}`;
};

export const getDoctorFullName = (person: MedicalStaff) => {
  return `${person?.title ?? ''} ${person?.first_name ?? ''} ${person?.last_name ?? ''}`;
};

export const formatGender = (gender: any) => {
  if (['M', 'm'].includes(gender)) gender = Gender.MALE_V4;
  if (['F', 'f'].includes(gender)) gender = Gender.FEMALE_V4;
  return gender;
};

export const formatCreatedPatient = (patient: CreatePatient) => {
  return {
    first_name: capitalize(patient.first_name) ?? '',
    marital_name: patient.last_name.toUpperCase() ?? '',
    birth_name: patient.birth_name ?? '',
    birth_date: patient.birth_date ? new Date(patient.birth_date).toISOString() : '',
    gender: formatGender(patient.gender),
    cns: patient.cns ?? '',
    health_fund_id: CNS_CODE,
    created_from_eprescription: true,
    addresses: patient?.addresses ?? {},
  };
};
